import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-white border-t-2 border-gray-200 pt-16 pb-8">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    <div className="space-y-6">
                        <Link to="/" className="inline-block">
                            <img src="/visiopadel-logo.png" alt="VisioPadel" className="h-20 w-auto object-contain" />
                        </Link>
                        <p className="text-gray-600 font-medium leading-relaxed">
                            La plataforma líder para conectar jugadores y clubes de pádel. Vive la experiencia competitiva definitiva.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-gray-900 font-black uppercase tracking-widest text-xs mb-6">Navegación</h4>
                        <ul className="space-y-3">
                            <li><Link to="/events" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Pozos</Link></li>
                            <li><Link to="/clubs" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Clubes</Link></li>
                            <li><Link to="/about" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Cómo funciona</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-gray-900 font-black uppercase tracking-widest text-xs mb-6">Comunidad</h4>
                        <ul className="space-y-3">
                            <li><Link to="/signup" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Únete</Link></li>
                            <li><a href="#" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Torneos</a></li>
                            <li><a href="#" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Ranking</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-gray-900 font-black uppercase tracking-widest text-xs mb-6">Ayuda</h4>
                        <ul className="space-y-3">
                            <li><a href="#" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Soporte</a></li>
                            <li><a href="#" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Términos</a></li>
                            <li><a href="#" className="text-gray-600 hover:text-primary-500 transition-colors font-medium">Privacidad</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-gray-500 text-sm font-medium">
                        &copy; {new Date().getFullYear()} VisioPadel. Todos los derechos reservados.
                    </p>
                    <div className="flex items-center gap-6">
                        <span className="text-gray-500 text-sm font-medium italic">Hecho con ❤️ para los amantes del pádel</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
